<ng-container *transloco="let t;">
  <div class="card-header">
    <div class="d-flex align-items-center">
      <h4 class="card-title font-medium-1">{{ t('Send a document (Dashboard upload document widget title) - Send a document') }}</h4>
    </div>
  </div>
  <div class="card-body" (fileDropped)="onFileDropped($event)" appDropFiles [class.disabled]="loading">
    <div class="py-5 text-center font-medium-5 text-uppercase file-drop-zone position-relative">
      <input class="fileDrop" type="file" #uploadFileInput (change)="onFileDropped($event)" [accept]="acceptableFiles" [disabled]="loading"/>
      <div *ngIf="loading" class="loading-overlay">
        <div class="spinner-border text-primary" role="status">
          <span class="sr-only">Uploading...</span>
        </div>
        <p>Uploading...</p>
      </div>
      {{ t('Drop files here or click to upload (Dashboard upload document widget) - Drop files here or click to upload') }}
    </div>
  </div>
</ng-container>
